import React, { useState } from 'react';
// import axios from 'axios'; // <-- Ya no usamos axios directamente
import api from './apiService'; // <-- MODIFICADO: Usamos el apiService
import { useNavigate } from 'react-router-dom';
import './Login.css';


function Login({ setSession }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const [msg, setMsg] = useState('');

  // const apiPort = process.env.REACT_APP_API_PORT || 7001; // <-- Ya no es necesario

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      // const apiDir = ... // <-- Ya no es necesario, apiService maneja la URL

      // <-- MODIFICADO: Usamos 'api' y la ruta relativa. 'apiService' pondrá la baseURL por defecto.
      const response = await api.post('/api/login', { 'username': username, 'password': password });
      
      // const { access_token, user } = response.data; // <-- MODIFICADO: Obtenemos toda la data
      const loginData = response.data;

      // localStorage.setItem('access_token', access_token); // <-- MODIFICADO: App.js se encarga de esto
      // localStorage.setItem('user', JSON.stringify(user)); // <-- MODIFICADO: App.js se encarga de esto
      
      // --- ¡ESTA ES LA CORRECCIÓN CLAVE! ---
      // Pasamos el objeto de login COMPLETO (incluyendo accessible_stores) a App.js
      setSession(loginData); 
      // --- FIN DE LA CORRECCIÓN ---

      navigate('/'); // App.js decidirá si mostrar el selector de tienda o el Home
    } catch (error) {
      console.error('Login failed', error);
      setMsg('Ingreso fallido. Por favor, revise usuario y contraseña.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <h2>Inicie Sesión</h2>
        <form onSubmit={handleLogin}>
          <div>
            <label>Usuario:</label>
            <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} />
          </div>
          <div>
            <label>Contraseña:</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <button type="submit">Login</button>
          {msg !== '' && 
          <div>
            <p>{msg}</p>
          </div>
          }
        </form>
      </div>
    </div>
  );
}

export default Login;
